import './AddToCartButtonContainer.scss';

import { AddToCartButton } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart';
import QtyInput from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/QtyInput/QtyInput';
import React from 'react';
import { useAvailabilityInfo } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Cart/AddToCartButton';

export function AddToCartButtonContainer(props: {
    product: any;
    qtyValue: number;
    setQtyValue: any;
    small?: boolean;
    setCartVisible?: boolean;
}) {
    const { product, qtyValue, setQtyValue, small, setCartVisible } = props;
    const { allowAddToCart } = useAvailabilityInfo(product);
    const className = 'add-to-cart-button';
    return (
        <div className='addCartWrapper'>
            <div className={`addToCart ${small && 'small'}`}>
                <QtyInput
                    product={product}
                    qtyValue={qtyValue}
                    setQtyValue={setQtyValue}
                />
                <AddToCartButton
                    className={
                        allowAddToCart ? className : `${className} disabled`
                    }
                    product={product}
                    qty={qtyValue}
                    small={small}
                    setCartVisible={setCartVisible}
                />
            </div>
        </div>
    );
}
